import { useMutation } from '@tanstack/react-query'

import { fetchOneByPromoCode } from 'services/promo-codes'

export function useFetchPromoCode() {
  return useMutation(fetchOneByPromoCode)
}
